import { render, staticRenderFns } from "./participant-consent-modal.vue?vue&type=template&id=87f703fe&scoped=true&"
import script from "./participant-consent-modal.vue?vue&type=script&lang=js&"
export * from "./participant-consent-modal.vue?vue&type=script&lang=js&"
import style0 from "./participant-consent-modal.vue?vue&type=style&index=0&id=87f703fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f703fe",
  null
  
)

component.options.__file = "participant-consent-modal.vue"
export default component.exports